const renameCategory = (category, categoryIndex, updatedCategories) => {
  let currentCategory = category;
  const nameSegments = [];
  const parents = [];

  while (currentCategory) {
    nameSegments.unshift(currentCategory.name);
    const parentCategoryId = currentCategory.parentCategoryId;

    if (parentCategoryId && updatedCategories.some(c => c.id === parentCategoryId)) {
      const parentCategory = updatedCategories.find(c => c.id === parentCategoryId);
      nameSegments.unshift(parentCategory.name);
      break;
    }

    if (parentCategoryId) {
      parents.push(parentCategoryId.toString());
    }

    currentCategory = categoryIndex[parentCategoryId];
  }

  const fullName = nameSegments.join('/');
  updatedCategories.push({ ...category, name: fullName, parents });
};

const processCategories = (categoriesResult) => {
  const categories = categoriesResult.map(category => ({
    id: String(category.id),
    ..._.pick(category, ['name', 'parentCategoryId'])
  }));

  const categoryIndex = _.keyBy(categories, 'id');
  const updatedCategories = [];

  categories.forEach(category => {
    if (!updatedCategories.some(c => c.id === category.id)) {
      renameCategory(category, categoryIndex, updatedCategories);
    }
  });

  return _.sortBy(updatedCategories, ['name', 'parentCategoryId']);
};

module.exports = {
  processCategories
};